 function initialzeModalTargetting() {
  $(document).on('click', '[data-dismiss-modal]', function() {
    let modal = this.closest('.modal');

    if (!modal)
      return;

    modal.dataset.manualDismiss = true
    $(modal).modal('hide');
  });

  $(document).on('click', '[data-modal-target]', function() {
    if (this.classList.contains('modal-target-initialized'))
      return;

    this.classList.add('modal-target-initialized');

    $(this.dataset.modalTarget)
      .on('shown.bs.modal', function () {
        this.dataset.targetModal = 'target';
      })
      .on('hidden.bs.modal', async (ev) => {
        this.classList.remove('modal-target-initialized')

        if (ev.target.getAttribute('id') != this.dataset.modalTarget.replaceAll('#', ''))
          return;

        if (!!ev.target.dataset.manualDismiss)
          return

        if (!this.dataset.onHiddenModal)
          return;

        if (this.dataset.onHiddenModal === '_self') {
          let turboFrame = this.closest('turbo-frame');

          if (!turboFrame)
            return;

          turboFrame.classList.add('backdrop-filter');
          !!turboFrame && turboFrame.reload();
          await turboFrame.loaded;

          turboFrame.classList.remove('backdrop-filter');
        }

        if (this.dataset.onHiddenModal === 'location')
          window.location.reload();
      })
      .modal('show');
  });
}

$(() => { initialzeModalTargetting() });
document.addEventListener("turbo:load", initialzeModalTargetting);